import React, { useState, useEffect } from "react"
import { useHistory, useParams } from "react-router"
import {
  getManagePaytmMerchantById,
  getAllPaytmTerminalsById
} from "../../../../core/services/api"
import Button from "../../../../components/Button"
import Table from "../../../../components/Table"
import { PAYTM_TERMINAL_COLUMNS } from "./PaytmTerminalColumn"
import PaytmTermialForm from "./EditOrAddTerminalModal"
import "./AddOrEditTerminal.scss"


function AddPaytmTerminal() {
  const history = useHistory()
  const { id }: any = useParams()
  const [editOrAddTerminal, setEditOrAddTerminal] = useState<any>(false)
  const [paytmTerminalId, setPaytmTerminalId] = useState<any>(null)
  const [paytmTerminals, setPaytmTerminals] = useState<any>([]);

  const [managePaytmMerchantInfo, setManagePaytmMerchantInfo] = useState<any>({
    id: "",
    centerId: "",
    centerName: "",
    merchantId: "",
    merchantKey: "",
    channelId: "",
    status: "",
  })

  useEffect(() => {
    fetchManagePaytmMerchantById()
    fetchPaytmTerminals()
  }, [])

  const fetchManagePaytmMerchantById = () => {
    if (id) {
      getManagePaytmMerchantById(id)
        .then((res) => {
          setManagePaytmMerchantInfo({
            id: res?.id,
            centerId: res?.centerId,
            centerName: res?.centerName,
            merchantId: res.merchantId,
            merchantKey: res?.merchantKey,
            channelId: res?.channelId,
            status: res?.status,
          })
        })
        .catch((err) => {
          console.log("Err,", err)
        })
    }
  }

  const fetchPaytmTerminals = () => {
    if (id) {
      getAllPaytmTerminalsById(id)
        .then((res) => {
          setPaytmTerminals(res)
        })
        .catch((err) => {
          console.log("err", err)
        })
    }
  }

  const handleEditOrAddTerminal = (id = null) => {
    setPaytmTerminalId(id)
    setEditOrAddTerminal(true)
  }

  return (
    <div className="automatic-id-generation-wrapper">
      <div className="heading">
        <div
          className="back-image"
          onClick={() => {
            history.push("/managePaytmMerchants")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
          />
        </div>
        <div className="header-text">Add/Edit Paytm Terminal</div>
      </div>

      <div className="p-4 border rounded-md">
        <div className="row">
          <div className="col-6 col-md-6 col-lg-6">
            <div className="d-flex flex-row mb-4">
              <span className="heading">Center:&nbsp;
              </span>
              <span>{managePaytmMerchantInfo?.centerName}</span>
            </div>
            <div className="d-flex flex-row ">
              <span className="heading">Channel ID:&nbsp;
              </span>
              <span>{managePaytmMerchantInfo?.channelId}</span>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-6 p-0">
            <div className="d-flex flex-row mb-4">
              <span className="heading">Merchant ID:&nbsp;
              </span>
              <span>{managePaytmMerchantInfo?.merchantId}</span>
            </div>
            <div className="d-flex flex-row">
              <span className="heading">Status:&nbsp;
              </span>
              <span style={{ color: managePaytmMerchantInfo?.status?.toLowerCase() === "active" ? "green" : "red" }}>{managePaytmMerchantInfo?.status}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="manage-centers-container pt-4">
        <div className="d-flex justify-content-end">
          <Button text="Add Paytm Terminal"
            onClick={() => {
              handleEditOrAddTerminal()
            }} id="add-paytm-terminal" />
        </div>
        {(paytmTerminals.length > 0) ?
          <Table
            data={paytmTerminals}
            columns={PAYTM_TERMINAL_COLUMNS}
            globalFilterRequired={false}
            onRowClick={(id: any) => handleEditOrAddTerminal(id)}
            onColClick={() => { }}
          />
          : null}

        {editOrAddTerminal === true && (
          <PaytmTermialForm
            show={editOrAddTerminal}
            closePrintModal={(close: boolean) => {
              setEditOrAddTerminal(close)
              fetchPaytmTerminals()
            }
            }
            managePaytmMerchantInfo={managePaytmMerchantInfo}
            paytmTerminals={paytmTerminals}
            paytmTerminalId={paytmTerminalId}
            centerPaytmMerchantId={id}
          />
        )}
      </div>
    </div>
  )
}
export default AddPaytmTerminal
